import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlertasAbertos } from "./services";
import { TGetAlertasAbertos } from "./types";

const initialState: any = {
  status: "",
  data: [],
};

interface FetchAlertasParams {
  idLoja?: number | string | null;
  idCliente?: number;
  idRegional?: number;
  pagina?: number;
  itensPorPagina?: number;
}

export const actionGetAlertasAbertos = createAsyncThunk(
  "ACTION_GET_ALERTAS_ABERTOS",
  async (params: FetchAlertasParams, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
    } = getState();

    const finalIdLoja = lojaSelected || params.idLoja || 0;
    const finalIdCliente = params.idCliente || 0;
    const finalIdRegional = params.idRegional || 0;

    const finalPagina = params.pagina || 1;
    const finalItensPorPagina = params.itensPorPagina || 50;

    console.log(
      `Buscando alertas -> Loja: ${finalIdLoja}, Cliente: ${finalIdCliente}, Regional: ${finalIdRegional} | Pág: ${finalPagina} (Lim: ${finalItensPorPagina})`,
    );

    return getAlertasAbertos(
      finalIdLoja,
      finalIdCliente,
      finalIdRegional,
      finalPagina,
      finalItensPorPagina,
    );
  },
);

const sliceGetAlertasAbertos = createSlice({
  name: "GET_ALERTAS_ABERTOS",
  initialState,
  reducers: {
    clearAlerts: (state) => {
      state.data = [];
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(actionGetAlertasAbertos.pending, (state) => {
        state.status = "loading";
      })

      .addCase(actionGetAlertasAbertos.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
      })

      .addCase(actionGetAlertasAbertos.rejected, (state, action) => {
        state.status = "error";

        console.error("Erro ao buscar alertas:", action.error.message);
      });
  },
});

export const { clearAlerts } = sliceGetAlertasAbertos.actions;
export default sliceGetAlertasAbertos.reducer;
